// BusinessCard.js
import React, { useCallback, useState, useEffect, useContext, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../Components/AuthContext';
import Navbar from '../Components/Navbar';
import Products from '../Components/Products';
import Sample from '../Components/Sample';
import Subscribe from '../Components/SubscribeSection';
import FixedImageMessage from '../Components/FixedImageMessage';
import Footer from '../Components/Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Pagination, Autoplay } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import danger  from  '../Images/danger.png'; 
import image  from  '../Images/image.png'; 
import add  from  '../Images/add.png'; 
import arrow  from  '../Images/arrow-white.png'; 
import arrow2  from  '../Images/Arrow2.png'; 
import LoginModal from '../Components/LoginModal';
import { pushDataLayerEvent } from '../utils/tracking';



const Product = ({  }) => {
  const location = useLocation();
  const itemId  = location.state?.id ;
  const productId = location.state?.productId;
  console.log('itemId', itemId);
  console.log('productId', productId);
  const navigate = useNavigate();
  const productEditData = location.state?.product;
  const [productData, setProductData] = useState(productEditData ?? null);
  const { token, userData } = useContext(AuthContext);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
const [savedDate, setSavedDate] = useState('');
const [savedTotalPrice, setSavedTotalPrice] = useState('');
const [serviceText, setServiceText] = useState('');
const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedPaperType, setSelectedPaperType] = useState('');
  const [selectedWeight, setSelectedWeight] = useState('');
  const [selectedOrientation, setSelectedOrientation] = useState([]);
  const [selectedPrintedSides, setSelectedPrintedSides] = useState("");
  const [selectedCornerCutStyle, setSelectedCornerCutStyle] = useState('');
  const [cornerCutStyles, setCornerCutStyles] = useState([]);
  const [selectedWhiteColor, setSelectedWhiteColor] = useState(null);
  const [whiteColorOption, setWhiteColorOption] = useState([]);
  const [selectedSpotUV, setSelectedSpotUV] = useState(null);
  const [spotUVOptions, setSpotUVOptions] = useState([]);
  const [selectedQuantity, setSelectedQuantity] = useState(null);
  const [selectedDate, setSelectedDate] = useState(0);
  const [quantityPrice, setQuantityPrice] = useState([]);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [sizes, setSizes] = useState([]); 
  const [sizeDetails, setSizeDetails] = useState([]);
  const [selectedSize, setSelectedSize] = useState('');
  const [customSize, setCustomSize] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [widthError, setWidthError] = useState('');   
  const [heightError, setHeightError] = useState(''); 
  const [paperTypes, setPaperTypes] = useState([]); 
  const [paperDetails, setPaperDetails] = useState([]); 
  const [paperWeights, setPaperWeights] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedFoiling, setSelectedFoiling] = useState('');  
  const [note, setNote] = useState('');
  const [foilingColors, setFoilingColors] = useState([]);
  const [availableOrientations, setAvailableOrientations] = useState([]);
  const [printedSides, setPrintedSides] = useState([]);
  const [laminations, setLaminations] = useState([]);  
  const [selectedLamination, setSelectedLamination] = useState("");
  const [designRequired, setDesignRequired] = useState('no');
  const [selectedService, setSelectedService] = useState('');
  const [services, setServices] = useState([]);
  const [isProofModalOpen, setIsProofModalOpen] = useState(false);
  const [selectedProof, setSelectedProof] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [fileName, setFileName] = useState('');
  
  // const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [selectedImage, setSelectedImage] = useState('first'); // Default to 'first' image selection
  const [uploadedImageUrl, setUploadedImageUrl] = useState(''); // First image URL
  const [uploadedImageUrl2, setUploadedImageUrl2] = useState(''); // Second image URL
  const [vatRate, setVatRate] = useState('');
  const [customWidth, setCustomWidth] = useState(null);
  const [customHeight, setCustomHeight] = useState(null);
  const [errors, setErrors] = useState({
    size          : '',
    paperType     : '',
    paperWeight   : '',
    quantity      : '',
    service       : '',
    printedSide   : '',
    orientation   : '',
    lamination    : '',
    foilingColor  : '',
    cornerCut     : '',
    spotUV        : '',
    whiteColor    : '',
  });

  const [mandatory, setMandatory] = useState({
    printed_side    : 0,
    orientation     : 0,
    lamination      : 0,
    foiling_color   : 0,
    corner_cut_style: 0,
    spot_UV         : 0,
    white_color     : 0,
  });
  const viewedItemRef = useRef('');

  
  useEffect(() => {
    setMandatory(prev => ({
      ...prev,
  
      printed_side: Array.isArray(printedSides) && printedSides.includes('one') && printedSides.includes('two'),
      spot_UV: Array.isArray(spotUVOptions) && spotUVOptions.includes(0) && spotUVOptions.includes(1),
      white_color: Array.isArray(whiteColorOption) && whiteColorOption.includes(0) && whiteColorOption.includes(1),
  
      orientation      : availableOrientations.length > 0,
      lamination       : laminations.length          > 0,
      foiling_color    : foilingColors.length        > 0,
      corner_cut_style : cornerCutStyles.length      > 0,
    }));
  }, [
    printedSides,
    spotUVOptions,
    whiteColorOption,
    availableOrientations,
    laminations,
    foilingColors,
    cornerCutStyles,
  ]);

  const validateSelections = () => {
    const newErrors = {
      size        : !selectedSize          ? 'Please select a size.'        : '',
      paperType   : !selectedPaperType     ? 'Please select a paper type.'  : '',
      paperWeight : !selectedWeight        ? 'Please select a paper weight.': '',
      quantity    : !selectedQuantity      ? 'Please select a quantity.'    : '',
      service     : !selectedServiceObject ? 'Please select a service.'     : '',
  
      printedSide: Array.isArray(printedSides) && printedSides.includes('one') && printedSides.includes('two') && !selectedPrintedSides ? 'Printed side is required.' : '',
      orientation : mandatory.orientation       && !selectedOrientation    ? 'Orientation is required.'     : '',
      // lamination  : mandatory.lamination        && !selectedLamination     ? 'Lamination is required.'      : '',
      foilingColor: mandatory.foiling_color     && !selectedFoiling        ? 'Foiling colour is required.'  : '',
      cornerCut   : mandatory.corner_cut_style  && !selectedCornerCutStyle ? 'Corner-cut style is required.': '',
      spotUV:  Array.isArray(spotUVOptions) &&  spotUVOptions.includes(0) && spotUVOptions.includes(1) &&  !selectedSpotUV    ? 'Spot UV selection is required.' : '',
      whiteColor:  Array.isArray(whiteColorOption) &&  whiteColorOption.includes(0) &&  whiteColorOption.includes(1) && !selectedWhiteColor ? 'White colour option is required.' : '',    
    };
  
    setErrors(newErrors);
    return Object.values(newErrors).every(msg => msg === '');
  };
  

  
 useEffect(() => {
    if (location.state?.scrollToPromo) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
   }
 }, [location.state]);
  
useEffect(() => {
  window.scrollTo(0, 0);
}, []);

const fetchUpdatedPrice = async (updatedFields = {}) => {
  try {
    const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId: productId,
        size: selectedSize,
        paper_type: selectedPaperType,
        paper_weight: selectedWeight,
        foiling_color: selectedFoiling,
        orientation: selectedOrientation,
        lamination: selectedLamination,
        white_color: selectedWhiteColor === 'With white color' ? 1 : 0,
        spot_UV: selectedSpotUV === 'Yes' ? 1 : 0,
        printed_side: selectedPrintedSides === 'One Side' ? 'one' : 'two',
        custom_size: customSize ? 1 : 0,
        width: customWidth || '',
        length: customHeight || '',
        ...updatedFields
      }),
    });

    const data = await response.json();

    setQuantityPrice(data.data.quantity_price || []);
  } catch (error) {
    console.error('❌ Error updating quantity price:', error);
  }
};


const handleLoginSuccess = () => {
  window.location.reload(); // Reload the entire page on login success
};

// useEffect(() => {
//   if (productEditData) {
//     setSelectedPaperType(productEditData.old_product_data.paper_type);
//     setSizes(productEditData.sizes); // Set sizes from product data
//   }
// }, [productEditData]);
  // Function to parse width and height from selected size (in the format "85mm x 55mm")
  const getSizeDimensions = (size) => {
    console.log("Getting size dimensions for:", size);
  
    if (size === customSize) {
      console.log("Custom size dimensions (customWidth x customHeight):", { customWidth, customHeight });
      
      return {
        outerWidth: customWidth || 0,   // Use customWidth state
        outerHeight: customHeight || 0, // Use customHeight state
      };
    }
  
    // Check for preset sizes
    const foundSize = sizeDetails.find(detail => detail.name === size);
    if (foundSize) {
      console.log("Found preset size dimensions (width x height):", { width: foundSize.width, height: foundSize.length });
      return {
        outerWidth: foundSize.width,
        outerHeight: foundSize.length,
      };
    }
  
    console.log("No matching size found. Returning default 0mm dimensions.");
    return { outerWidth: 0, outerHeight: 0 };
  };
  

  // useEffect(() => {
  //   if (paperTypes.length > 0 && !selectedPaperType) {
  //     const firstType = paperTypes[0];
  //     setSelectedPaperType(firstType);
  //     handlePaperTypeSelect(firstType);
  //   }
  // }, [paperTypes]);

  useEffect(() => {
    if (paperWeights.length > 0 && !selectedWeight) {
      const firstWeight = paperWeights[0];
      setSelectedWeight(firstWeight);
      handlePaperWeightSelect(firstWeight); 
    }
  }, [paperWeights]);
  
  

  
  
  
  useEffect(() => {
    if (selectedSize) {
      const { outerWidth, outerHeight } = getSizeDimensions(selectedSize);
      console.log("Effect triggered: selectedSize or customSize changed.");
      console.log("Current selectedSize:", selectedSize);
      console.log("Calculated Dimensions (outerWidth x outerHeight):", { outerWidth, outerHeight });
    }
  }, [selectedSize, customWidth, customHeight]);  // Include customWidth and customHeight in the dependencies
  


const mmToPx = (mm) => `${mm * 3.78}px`;

const { outerWidth, outerHeight } = getSizeDimensions(selectedSize); 

console.log("Parsed Dimensions:", { outerWidth, outerHeight });

const onDrop = useCallback((acceptedFiles) => {
  if (acceptedFiles.length > 0) {
    // 1️⃣ Store the raw File objects for later
    setUploadedFiles(acceptedFiles);

    // 2️⃣ Continue to generate preview URLs as before
    const file1 = acceptedFiles[0];
    const file2 = acceptedFiles[1];

    const imageUrl1 = URL.createObjectURL(file1);
    setUploadedImageUrl(imageUrl1);

    if (selectedPrintedSides === 'Two Sides' && file2) {
      const imageUrl2 = URL.createObjectURL(file2);
      setUploadedImageUrl2(imageUrl2);
    } else {
      setUploadedImageUrl2('');
    }

    // 3️⃣ Show the file names
    setFileName(acceptedFiles.map(f => f.name).join(', '));
    setFileUploaded(true);

  }
}, [selectedPrintedSides, productId, productData]);

const MAX_FILE_SIZE = 25 * 1024 * 1024 * 1024;

const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
  onDrop,
  multiple: selectedPrintedSides === 'Two Sides', 
  maxSize: MAX_FILE_SIZE,
  accept: {

    'image/jpeg': ['.jpeg', '.jpg'],
    'image/png':  ['.png'],
    'image/tiff': ['.tiff', '.tif'],

    'application/pdf':          ['.pdf'],

    'application/postscript':   ['.eps'], 
    'application/illustrator':  ['.ai'],  
    'image/vnd.adobe.photoshop':['.psd'], 
    'image/svg+xml':            ['.svg'],
  },
  onDropRejected: rejected => {
  }
});




  // Toggle the dropdown on click
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };




  const getSizeClasses = (option) => {
    if (option === 'portrait') return 'h-20 w-12';
    if (option === 'landscape') return 'h-12 w-28';
    if (option === 'square') return 'h-16 w-16';
  };
  



  useEffect(() => {
    if (!itemId) return;
  
    (async () => {
      try {
        const res = await fetch(
          `https://backend.printtrio.co.uk/api/cart/view-edit-item/${itemId}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const { data } = await res.json();
        const old = data.old_product_data;
  
        // ── 1️⃣ Seed all the form fields from old_product_data ─────────
        setProductData(data.product);
        setSizes(data.sizes);
        setPaperTypes(data.paper_type);
        setPaperDetails(data.paper_detail);
        setFoilingColors(data.foiling_color);
        setAvailableOrientations(data.orientation);
        setPrintedSides(data.printed_side);
        setLaminations(data.lamination);
        setCornerCutStyles(data.corner_cut_style);
        setWhiteColorOption(data.white_color);
        setSpotUVOptions(data.spot_UV);
  
        setSelectedSize(old.size);
        setCustomSize(old.custom_size ? old.size : '');
        // ← seed width & height here for the edit form:
        setWidth(old.custom_width?.toString() || '');
        setHeight(old.custom_length?.toString() || '');
  
        // use your handlers so every dependent option list & price table reloads
        await handlePaperTypeSelect(old.paper_type);
        await handlePaperWeightSelect(old.paper_weight);
  
        setSelectedPrintedSides(old.printed_side === 'one' ? 'One Side' : 'Two Sides');
        setSelectedOrientation(typeof old.orientation === 'string' ? old.orientation : (Array.isArray(old.orientation) ? old.orientation[0] : ''));
        setSelectedFoiling(old.foiling_color);
        setSelectedLamination(old.lamination);
        setSelectedCornerCutStyle(old.corner_cut_style);
        setSelectedWhiteColor(old.white_color === 1 ? 'With white color' : 'Without white color');
        setSelectedSpotUV(old.spot_UV === 1 ? 'Yes' : 'No');
  
        // ── 2️⃣ **Now** re-fetch the live quantity_price & services ──────
        await fetchUpdatedProductData(
          old.size,
          old.paper_type,
          old.paper_weight,
          {
            printed_side: old.printed_side,
            orientation: old.orientation,
            lamination: old.lamination,
            corner_cut_style: old.corner_cut_style,
            white_color: old.white_color,
            spot_UV: old.spot_UV,
            foiling_color: old.foiling_color,
            custom_size: old.custom_size,
            width: old.custom_width,
            length: old.custom_length,
          }
        );
  
        // ── 3️⃣ Only after quantityPrice is populated do we set these ────
        setSelectedQuantity(old.quantity);
        const idx = quantityPrice.findIndex(q =>
          q.date1 === old.deliver_date ||
          q.date2 === old.deliver_date ||
          q.date3 === old.deliver_date
        );
        setSelectedDate(idx >= 0 ? idx : 0);
  
        // ── 4️⃣ file previews ────────────────────────────────────────────
        setUploadedImageUrl(old.file1_url || '');
        setUploadedImageUrl2(old.file2_url || '');
        setFileUploaded(true);
        setFileName([old.file1_name, old.file2_name].filter(Boolean).join(', '));
      } catch (err) {
        console.error('❌ Failed to load cart item for editing:', err);
      }
    })();
  }, [itemId, token]);
  


  
  

  


  useEffect(() => {
    const fetchProductData = async () => {
      setIsLoading(true);
      try {
        // Check if itemId (cart item ID) is available, and use the appropriate API
        const url = itemId 
          ? `https://backend.printtrio.co.uk/api/cart/view-edit-item/${itemId}` 
          : 'https://backend.printtrio.co.uk/api/product/single-product';
    
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({
            productId: productId || '', // Only pass productId if it's defined
            custom_size: 0,
          }),
        });
  
        const data = await response.json();
  
        // Log the entire API response to check if services are returned
        console.log("Full API Response (view-edit-item):", data);
        console.log("Services:", data.data.services);
  
        // Set product data
        setSizeDetails(data.data.size_detail);
        setProductData(data.data.product);
        setMandatory(data.data.product?.mandatory_detail ?? {});
        setSizes(data.data.sizes);
        setPaperTypes(data.data.paper_type);
        setPaperDetails(data.data.paper_detail);
        setPaperWeights(data.data.paper_weight);
        setFiles(data.data.product.files);
        setFoilingColors(data.data.foiling_color || []);
        setNote(data.data.product.note || 'No additional notes available.');
        setAvailableOrientations(data.data.orientation || []);
        setPrintedSides(data.data.printed_side);
        setLaminations(data.data.lamination);
        setCornerCutStyles(data.data.corner_cut_style || []);
        setWhiteColorOption(data.data.white_color);
        setSpotUVOptions(data.data.spot_UV);
        setQuantityPrice(data.data.quantity_price || []);
  
        // Set services and log to confirm
        setServices(data.data.services || []);
        console.log("Services set in state:", data.data.services);
  
        const vatString = data.data.vat;
        const vatValue = parseFloat(vatString);
        setVatRate(!isNaN(vatValue) ? vatValue : 0);
        console.log("VAT Value fetched from API:", vatValue);
  
        if (data.data.quantity_price.length > 0) {
          setSelectedQuantity(data.data.quantity_price[0]?.quantity);
          setSelectedDate(0); // Default to first available date (index 0)
        }
      } catch (error) {
        console.error('Error fetching product:', error);
      } finally {
        setIsLoading(false);   // ← turn off spinner no matter what
      }
    };
  
    if (itemId || productId) {
      fetchProductData(); // Fetch data based on itemId or productId
    }
  },  [productEditData, itemId, productId]);

useEffect(() => {
  setSelectedSize('');
  setCustomSize('');
  setSelectedPaperType('');
  setSelectedWeight('');
  setSelectedPrintedSides('');
  setSelectedOrientation('');
  setSelectedFoiling('');
  setSelectedSpotUV(null);
  setSelectedWhiteColor(null);
  setSelectedLamination('');
  setSelectedCornerCutStyle('');
  setSelectedQuantity(null);
  setSelectedDate(0);
}, [productId]);

  
  const applyApiData = (api) => {
    if (api.product) setProductData(api.product);
    if (api.product?.note) setNote(api.product.note);
    if (api.vat) setVatRate(parseFloat(api.vat));
  
    if (Array.isArray(api.size_detail)) setSizeDetails(api.size_detail);
    if (Array.isArray(api.sizes)) setSizes(api.sizes);
    if (Array.isArray(api.quantity_price)) setQuantityPrice(api.quantity_price);
    if (Array.isArray(api.services)) setServices(api.services);
  
    if (Array.isArray(api.paper_type)) setPaperTypes(api.paper_type);
    if (Array.isArray(api.paper_detail)) setPaperDetails(api.paper_detail);
    if (Array.isArray(api.paper_weight)) setPaperWeights(api.paper_weight);
  
    if (Array.isArray(api.foiling_color)) setFoilingColors(api.foiling_color);
    if (Array.isArray(api.orientation)) setAvailableOrientations(api.orientation);
    if (Array.isArray(api.printed_side)) setPrintedSides(api.printed_side);
    if (Array.isArray(api.lamination)) setLaminations(api.lamination);
    if (Array.isArray(api.corner_cut_style)) setCornerCutStyles(api.corner_cut_style);
    if (Array.isArray(api.white_color)) setWhiteColorOption(api.white_color);
    if (Array.isArray(api.spot_UV)) setSpotUVOptions(api.spot_UV);
  
    if (Array.isArray(api.product?.files)) setFiles(api.product.files);
  };
  

  // const buildRequestPayload = (extra = {}) => ({
  //   productId      : productId,
  //   size           : selectedSize,
  //   paper_type     : selectedPaperType,
  //   paper_weight   : selectedWeight,
  //   orientation    : selectedOrientation,
  //   lamination     : selectedLamination,
  //   white_color    : selectedWhiteColor === 'With white color' ? 1 : 0,
  //   spot_UV        : selectedSpotUV === 'Yes' ? 1 : 0,
  //   printed_side   : selectedPrintedSides === 'One Side' ? 'one' : 'two',
  //   foiling_color  : selectedFoiling,
  //   custom_size    : customSize ? 1 : 0,
  //   width          : customWidth || '',
  //   length         : customHeight || '',
  //   ...extra,                // allow the caller to override / add a field
  // });


  const buildRequestPayload = (extra = {}) => ({
    productId,
    size:           selectedSize,
    paper_type:     selectedPaperType,
    paper_weight:   selectedWeight,
    // orientation:    selectedOrientation,
    // lamination:     selectedLamination,
    // white_color:    selectedWhiteColor === 'With white color' ? 1 : 0,
    // spot_UV:        selectedSpotUV === 'Yes' ? 1 : 0,
    // printed_side:   selectedPrintedSides === 'One Side' ? 'one' : 'two',
    // foiling_color:  selectedFoiling,
    custom_size:    customSize ? 1 : 0,
    // width:          customWidth || '',
    // length:         customHeight || '',
    ...extra,
  });

  const fetchBareMinimumPrice = async (params = {}) => {
    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productId,
          custom_size: customSize ? 1 : 0,
          width: customSize ? customWidth : '',
          length: customSize ? customHeight : '',
          ...params,
        }),
      });
  
      const data = await response.json();
      if (data.success && data.data) {
        setProductData(data.data.product);
        setMandatory(data.data.product?.mandatory_detail ?? {});
        setQuantityPrice(data.data.quantity_price || []);
        setServices(data.data.services || []);
        const vatValue = parseFloat(data.data.vat);
        setVatRate(!isNaN(vatValue) ? vatValue : 0);
  
        if (data.data.quantity_price.length > 0) {
          setSelectedQuantity(data.data.quantity_price[0]?.quantity);
          setSelectedDate(0);
        }
      } else {
        console.warn("⚠️ Unexpected response from API:", data);
      }
    } catch (error) {
      console.error("🚨 Error in fetchBareMinimumPrice:", error);
    }
  };
  
  const fetchUpdatedProductData = async (
  size = selectedSize,
  paperType = selectedPaperType,
  weight = selectedWeight,
  extra = {}
) => {
  try {
    const payload = {
      productId,
      size,
      paper_type: paperType,
      paper_weight: weight,
      custom_size: customSize ? 1 : 0,
      width:       customSize ? customWidth  : null,
      length:      customSize ? customHeight : null,
      printed_side:    selectedPrintedSides === 'One Side' ? 'one' : 'two',
      orientation:     selectedOrientation,
      foiling_color:   selectedFoiling,
      lamination:      selectedLamination,
      corner_cut_style:selectedCornerCutStyle,
      white_color:     selectedWhiteColor === 'With white color' ? 1 : 0,
      spot_UV:         selectedSpotUV === 'Yes' ? 1 : 0,
      ...extra
    };

    const res = await fetch(
      'https://backend.printtrio.co.uk/api/product/single-product',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }
    );
    const json = await res.json();
    if (json.success && json.data) {
      setProductData(json.data.product);
      setQuantityPrice(json.data.quantity_price || []);
      setServices(json.data.services || []);
    }
  } catch (err) {
    console.error('❌ Error fetching product data:', err);
  }
};

const fetchUpdatedProductData1 = async (
  size = selectedSize,
  paperType = selectedPaperType,
  weight = selectedWeight,
  extra = {}
) => {
  try {
    const fullPayload = {
      ...buildRequestPayload(),
      size,
      paper_type: paperType,
      paper_weight: weight,
      ...extra
    };

    // Ensure dimensions are sent if custom size
    if (fullPayload.custom_size) {
      fullPayload.width = customWidth || extra.custom_width || width;
      fullPayload.length = customHeight || extra.custom_length || height;
    }

    const res = await fetch(
      'https://backend.printtrio.co.uk/api/product/single-product',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(fullPayload),
      }
    );

    const json = await res.json();
    if (json.success && json.data) {
      setProductData(json.data.product);
      setQuantityPrice(json.data.quantity_price || []);
      setServices(json.data.services || []);
    }
  } catch (err) {
    console.error('❌ Error fetching product data:', err);
  }
};

const handleSizeSelect = async (newSize) => {
  // 1️⃣ Clear uploaded artwork
  setUploadedImageUrl('');
  setUploadedImageUrl2('');
  setFileUploaded(false);
  setFileName('');

  // 2️⃣ Clear all dependent selections
  setQuantityPrice([]);          
  setSelectedQuantity(null);
  setSelectedDate(0);
  setSelectedSpotUV(null);
  setSelectedWhiteColor(null);
  setSelectedCornerCutStyle('');
  setSelectedPrintedSides('');
  setSelectedOrientation('');
  setSelectedFoiling('');
  setSelectedPaperType(''); 
  setSelectedWeight('')     

  // 3️⃣ Set the new size
  setSelectedSize(newSize);

  // 4️⃣ If they chose “Custom Size”, open your modal and bail
  if (newSize === "Custom Size") {
    setCustomSize('');
    setIsModalOpen(true);
    return;
  }

  // 5️⃣ Fetch with just productId + size (custom_size = 0)
  try {
    const response = await fetch(
      'https://backend.printtrio.co.uk/api/product/single-product',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productId:   productId,
          size:        newSize,
          custom_size: 0
        }),
      }
    );
    const data = await response.json();

    // 6️⃣ Update everything from the response
    setProductData(data.data.product);
    setMandatory(data.data.product?.mandatory_detail ?? {});
    setSizes(data.data.sizes);
    setPaperTypes(data.data.paper_type);
    setPaperDetails(data.data.paper_detail);
    setPaperWeights(data.data.paper_weight);
    setFoilingColors(data.data.foiling_color);
    setAvailableOrientations(data.data.orientation || []);
    setPrintedSides(data.data.printed_side);
    setLaminations(data.data.lamination);
    setCornerCutStyles(data.data.corner_cut_style || []);
    setWhiteColorOption(data.data.white_color);
    setSpotUVOptions(data.data.spot_UV);
    setQuantityPrice(data.data.quantity_price || []);

    const vatValue = parseFloat(data.data.vat);
    setVatRate(!isNaN(vatValue) ? vatValue : 0);

    if (data.data.quantity_price.length > 0) {
      setSelectedQuantity(data.data.quantity_price[0].quantity);
      setSelectedDate(0);
    }
  } catch (error) {
    console.error('Error fetching product with selected size:', error);
  }
};

    
    
const handlePaperTypeSelect = async (newPaperType) => {
  const size = selectedSize;
  const weight = selectedWeight;
  const custom = customSize ? 1 : 0;

  // Clear selections that depend on paper type
  setQuantityPrice([]);
  setSelectedQuantity(null);
  setSelectedDate(0);
  setSelectedSpotUV(null);
  setSelectedWhiteColor(null);
  setSelectedCornerCutStyle('');
  setSelectedPrintedSides('');
  setSelectedOrientation('');
  setSelectedFoiling('');
  setSelectedPaperType(newPaperType);

  try {
    const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId: productId,
        paper_type: newPaperType,
        custom_size: 0,
      }),
    });

    const { data } = await response.json();
    const md = data.product?.mandatory_detail || {};

    // Update full option state
    setProductData(data.product);
    setMandatory(md);
    setPaperTypes(data.paper_type);
    setPaperDetails(data.paper_detail);
    setPaperWeights(data.paper_weight);
    setFoilingColors(data.foiling_color || []);
    setAvailableOrientations(data.orientation || []);
    setPrintedSides(data.printed_side || []);
    setLaminations(data.lamination || []);
    setCornerCutStyles(data.corner_cut_style || []);
    setWhiteColorOption(data.white_color || []);
    setSpotUVOptions(data.spot_UV || []);
    setQuantityPrice(data.quantity_price || []);

    const vatValue = parseFloat(data.vat);
    setVatRate(!isNaN(vatValue) ? vatValue : 0);

    // Synchronize state with available options
    const sync = (arr, def, setter, transform = v => v) => {
      const val = def ?? arr?.[0];
      if (val !== undefined && arr.includes(val)) setter(transform(val));
      else setter('');
    };

    const defaultPrintedSide = md.default_printed_side ?? data.printed_side?.[0];
    const defaultOrientation = md.default_orientation ?? data.orientation?.[0];
    const defaultLamination = md.default_lamination ?? data.lamination?.[0];
    const defaultFoilingColor = md.default_foiling_color ?? data.foiling_color?.[0];
    const defaultCornerCutStyle = md.default_corner_cut_style ?? data.corner_cut_style?.[0];
    const defaultWhiteColor = md.default_white_color ?? 0;
    const defaultSpotUV = md.default_spot_UV ?? 0;

    sync(data.printed_side, defaultPrintedSide, setSelectedPrintedSides, v => v === 'two' ? 'Two Sides' : 'One Side');
    sync(data.orientation, defaultOrientation, setSelectedOrientation);
    sync(data.lamination, defaultLamination, setSelectedLamination);
    sync(data.foiling_color, defaultFoilingColor, setSelectedFoiling);
    sync(data.corner_cut_style, defaultCornerCutStyle, setSelectedCornerCutStyle);
    setSelectedSpotUV(
      md.default_spot_UV === '1'
        ? 'Yes'
        : 'No'
    );

    // md.default_white_color is "1" or "0"
    setSelectedWhiteColor(
      md.default_white_color === '1'
        ? 'With white color'
        : 'Without white color'
    );


    if (data.quantity_price?.length) {
      setSelectedQuantity(data.quantity_price[0].quantity);
      setSelectedDate(0);
    }

    // ✅ Re-fetch updated price with selected default values
    await fetchUpdatedProductData(
      size,
      newPaperType,
      weight,
      {
        printed_side: defaultPrintedSide,
        orientation: defaultOrientation,
        lamination: defaultLamination,
        foiling_color: defaultFoilingColor,
        corner_cut_style: defaultCornerCutStyle,
        white_color: defaultWhiteColor,
        spot_UV: defaultSpotUV,
      }
    );
  } catch (error) {
    console.error('Error fetching product for paper type:', error);
  }
};



    
    
    const handlePaperWeightSelect = async (newWeight) => {
      
      setSelectedWeight(newWeight);  // Update the selected weight state
      fetchUpdatedProductData(selectedSize, selectedPaperType, newWeight);
      try {
        const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            productId: productId,
            paper_weight: newWeight, // Send the selected paper weight to the API
            custom_size: 0,
          }),
        });
    
        const data = await response.json();
    
        setProductData(data.data.product);
        setMandatory(data.data.product?.mandatory_detail ?? {});
        // setSizes(data.data.sizes);
        // setPaperTypes(data.data.paper_type);
        // setPaperDetails(data.data.paper_detail);
        // setFoilingColors(data.data.foiling_color);
        // setAvailableOrientations(data.data.orientation || []); 
        // setSelectedOrientation(data.data.orientation[0]); 
        // setPrintedSides(data.data.printed_side);
        // setLaminations(data.data.lamination);
        // setCornerCutStyles(data.data.corner_cut_style || []); 
        // setWhiteColorOption(data.data.white_color); 
        // setSpotUVOptions(data.data.spot_uv); 
        // setQuantityPrice(data.data.quantity_price || []); 
        const vatString = data.data.vat; 
        const vatValue = parseFloat(vatString); 
    
        setVatRate(!isNaN(vatValue) ? vatValue : 0); 
    
        console.log("VAT Value fetched from API:", vatValue);

        
        // Set default selected quantity and date (index 0)
        if (data.data.quantity_price.length > 0) {
          setSelectedQuantity(data.data.quantity_price[0]?.quantity);
          setSelectedDate(0); // Default to first available date (index 0)
        }
      } catch (error) {
        console.error('Error fetching product with selected paper weight:', error);
      }
    };

    useEffect(() => {
      console.log("✅ Services Updated:", services);
    }, [services]);

    
    
 // 1️⃣ A single “source of truth” for every API call:


    
    
    useEffect(() => {
      console.log("🔄 quantityPrice updated:", quantityPrice);
    }, [quantityPrice]);
    
    
    
   
    

    const handleFoilingColorSelect = async (newFoilingColor) => {
      // 1️⃣ Update local state immediately
      setSelectedFoiling(newFoilingColor);
      await fetchUpdatedProductData(
        selectedSize,
        selectedPaperType,
        selectedWeight,
        { foiling_color: newFoilingColor }
      );
    
      // 2️⃣ Build up only the fields that have actually been selected
      const extra = {
        foiling_color: newFoilingColor,
        custom_size: 0,
        productId: productId,

      };
      if (selectedPrintedSides) {
        extra.printed_side = selectedPrintedSides === 'One Side' ? 'one' : 'two';
      }
      if (selectedLamination) {
        extra.lamination = selectedLamination;
      }
      if (selectedCornerCutStyle) {
        extra.corner_cut_style = selectedCornerCutStyle;
      }
      if (selectedWhiteColor) {
        extra.white_color = selectedWhiteColor === 'With white color' ? 1 : 0;
      }
      if (selectedSpotUV) {          
        extra.spot_UV  = selectedSpotUV === 'Yes' ? 1 : 0;
      }
    
      try {
        // 3️⃣ Send the request
        const res = await fetch(
          'https://backend.printtrio.co.uk/api/product/single-product',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(buildRequestPayload(extra)),
          }
        );
        const { data } = await res.json();
        if (!data) throw new Error('empty response');
    
        // 4️⃣ Core updates (same in every handler)
        if (data.product) setProductData(data.product);
        if (data.product?.note) setNote(data.product.note);
        if (data.vat) setVatRate(parseFloat(data.vat));
    
        // 5️⃣ Price table
        if (Array.isArray(data.quantity_price) && data.quantity_price.length > 0) {
          setQuantityPrice(data.quantity_price);
        }
    
        // 6️⃣ All the option‑lists
        if (Array.isArray(data.white_color))    setWhiteColorOption(data.white_color);
        setSpotUVOptions(data.spot_UV || []);
        setFoilingColors(data.foiling_color || []);
        if (Array.isArray(data.printed_side))    setPrintedSides(data.printed_side);
      } catch (err) {
        console.error('Foiling‑color fetch failed:', err);
      }
    };
    
    





    
    
    
    
    const handleOrientationSelect = async (newOrientation) => {
      // Update selectedOrientation state
      setSelectedOrientation(newOrientation);
    
      try {
        const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            productId: productId,
            orientation: newOrientation,  // Send the selected orientation to the API
            custom_size: 0,  // If you are not handling a custom size here
          }),
        });
    
        const data = await response.json();
        // setProductData(data.data.product);       
        // setAvailableOrientations(data.data.orientation || []); 
        // setSelectedOrientation(data.data.orientation[0]);     
        // setSizes(data.data.sizes);                
        // setPaperTypes(data.data.paper_type);
        // setPaperDetails(data.data.paper_detail);
        // setPaperWeights(data.data.paper_weight);
        // setFoilingColors(data.data.foiling_color);
        // setPrintedSides(data.data.printed_side);
        // setLaminations(data.data.lamination);
        // setCornerCutStyles(data.data.corner_cut_style || []); 
        // setWhiteColorOption(data.data.white_color); 
        // setSpotUVOptions(data.data.spot_UV); 

      } catch (error) {
        console.error('Error fetching product with selected orientation:', error);
      }
    };
    
    const handlePrintedSidesSelect = async (newPrintedSide) => {
      // 1️⃣ Clear any uploaded files / previews
      setUploadedImageUrl('');
      setUploadedImageUrl2('');
      setFileUploaded(false);
      setFileName('');
      setSelectedImage('first');
    
      // 2️⃣ Update local state immediately
      setSelectedPrintedSides(newPrintedSide);
      await fetchUpdatedProductData(
        selectedSize,
        selectedPaperType,
        selectedWeight,
        { printed_side: newPrintedSide === 'One Side' ? 'one' : 'two' }
      );
    
      // 3️⃣ Build only the fields that have actually been chosen
      const extra = {
        printed_side: newPrintedSide === 'One Side' ? 'one' : 'two',
        custom_size: 0,
        productId: productId,

      };
      if (selectedFoiling)          extra.foiling_color     = selectedFoiling;
      if (selectedLamination)       extra.lamination        = selectedLamination;
      if (selectedCornerCutStyle)   extra.corner_cut_style  = selectedCornerCutStyle;
      if (selectedWhiteColor)       extra.white_color       = selectedWhiteColor === 'With white color' ? 1 : 0;
      if (selectedSpotUV)           extra.spot_UV           = selectedSpotUV === 'Yes' ? 1 : 0;
    
      try {
        // 4️⃣ Send to API
        const res = await fetch(
          'https://backend.printtrio.co.uk/api/product/single-product',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(buildRequestPayload(extra)),
          }
        );
        const { data } = await res.json();
        if (!data) throw new Error('empty response');
    
        // 5️⃣ Core updates (same in every handler)
        if (data.product)     setProductData(data.product);
        if (data.product?.note) setNote(data.product.note);
        if (data.vat)         setVatRate(parseFloat(data.vat));
    
        // 6️⃣ Price table
        if (Array.isArray(data.quantity_price) && data.quantity_price.length > 0) {
          setQuantityPrice(data.quantity_price);
        }
    
        // 7️⃣ All the option‑lists
        if (Array.isArray(data.white_color))    setWhiteColorOption(data.white_color);
        setSpotUVOptions(data.spot_UV    || []);
        setFoilingColors(data.foiling_color || []);
        setPrintedSides(data.printed_side     || []);
      } catch (err) {
        console.error('Printed‑sides fetch failed:', err);
      }
    };
    
    
    
    const handleLaminationSelect = async (newLamination) => {
      // 1️⃣ Update local state immediately
      setSelectedLamination(newLamination);
      await fetchUpdatedProductData(
        selectedSize,
        selectedPaperType,
        selectedWeight,
        { lamination: newLamination }
      );
    
      // 2️⃣ Build only the extra fields you need to send
      const extra = {
        lamination: newLamination,
        custom_size: 0,
        productId: productId,

      };
      if (selectedPrintedSides)    extra.printed_side     = selectedPrintedSides === 'One Side' ? 'one' : 'two';
      if (selectedFoiling)         extra.foiling_color   = selectedFoiling;
      if (selectedCornerCutStyle)  extra.corner_cut_style= selectedCornerCutStyle;
      if (selectedWhiteColor)      extra.white_color     = selectedWhiteColor === 'With white color' ? 1 : 0;
      if (selectedSpotUV)          extra.spot_UV         = selectedSpotUV === 'Yes' ? 1 : 0;
    
      try {
        // 3️⃣ Send to API with your shared buildRequestPayload helper
        const res = await fetch(
          'https://backend.printtrio.co.uk/api/product/single-product',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(buildRequestPayload(extra)),
          }
        );
        const { data } = await res.json();
        if (!data) throw new Error('empty response');
    
        // 4️⃣ Core updates (exactly the same in every handler)
        if (data.product)      setProductData(data.product);
        if (data.product?.note) setNote(data.product.note);
        if (data.vat)          setVatRate(parseFloat(data.vat));
    
        // 5️⃣ Update your dynamic lists
        if (Array.isArray(data.quantity_price) && data.quantity_price.length > 0) {
          setQuantityPrice(data.quantity_price);
        }
        if (Array.isArray(data.white_color))    setWhiteColorOption(data.white_color);
        setSpotUVOptions(data.spot_UV    || []);
        setFoilingColors(data.foiling_color || []);
        setPrintedSides(data.printed_side     || []);
        setLaminations(data.lamination       || []);
        setCornerCutStyles(data.corner_cut_style || []);
        setAvailableOrientations(data.orientation || []);
      } catch (err) {
        console.error('Lamination‑fetch failed:', err);
      }
    };
    
    
    
    const handleCornerCutStyleSelect = async (newCornerCutStyle) => {
      // 1️⃣ Update local state immediately
      setSelectedCornerCutStyle(newCornerCutStyle);
    
      await fetchUpdatedProductData(
        selectedSize,
        selectedPaperType,
        selectedWeight,
        { corner_cut_style: newCornerCutStyle }
      );
      // 2️⃣ Build only the extra fields that are actually selected
      const extra = {
        corner_cut_style: newCornerCutStyle,
        custom_size: 0,
        productId: productId,

      };
      if (selectedPrintedSides)    extra.printed_side      = selectedPrintedSides === 'One Side' ? 'one' : 'two';
      if (selectedFoiling)         extra.foiling_color    = selectedFoiling;
      if (selectedLamination)      extra.lamination       = selectedLamination;
      if (selectedWhiteColor)      extra.white_color      = selectedWhiteColor === 'With white color' ? 1 : 0;
      if (selectedSpotUV)          extra.spot_UV          = selectedSpotUV === 'Yes' ? 1 : 0;
    
      try {
        // 3️⃣ Send to API
        const res = await fetch(
          'https://backend.printtrio.co.uk/api/product/single-product',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(buildRequestPayload(extra)),
          }
        );
        const { data } = await res.json();
        if (!data) throw new Error('empty response');
    
        // 4️⃣ Core updates (identical in every handler)
        if (data.product)       setProductData(data.product);
        if (data.product?.note) setNote(data.product.note);
        if (data.vat)           setVatRate(parseFloat(data.vat));
    
        // 5️⃣ Refresh all of your option lists
        if (Array.isArray(data.quantity_price) && data.quantity_price.length > 0) {
          setQuantityPrice(data.quantity_price);
        }
        if (Array.isArray(data.white_color))     setWhiteColorOption(data.white_color);
        setSpotUVOptions(data.spot_UV     || []);
        setFoilingColors(data.foiling_color || []);
        setPrintedSides(data.printed_side     || []);
        setLaminations(data.lamination       || []);
        setCornerCutStyles(data.corner_cut_style || []);
        setAvailableOrientations(data.orientation || []);
      } catch (err) {
        console.error('Corner‑cut‑style fetch failed:', err);
      }
    };
    
    
    
    const handleWhiteColorSelect = async (newWhiteColor) => {
      // 1️⃣ Update local state immediately
      setSelectedWhiteColor(newWhiteColor);
      await fetchUpdatedProductData(
        selectedSize,
        selectedPaperType,
        selectedWeight,
        { white_color: newWhiteColor === 'With white color' ? 1 : 0 }
      );
    
      // 2️⃣ Build only the extra fields that are actually selected
      const extra = {
        white_color: newWhiteColor === 'With white color' ? 1 : 0,
        custom_size: 0,
        productId: productId,

      };
      if (selectedPrintedSides) extra.printed_side      = selectedPrintedSides === 'One Side' ? 'one' : 'two';
      if (selectedFoiling)      extra.foiling_color    = selectedFoiling;
      if (selectedLamination)    extra.lamination       = selectedLamination;
      if (selectedCornerCutStyle) extra.corner_cut_style = selectedCornerCutStyle;
      if (selectedSpotUV)        extra.spot_UV         = selectedSpotUV === 'Yes' ? 1 : 0;
    
      try {
        // 3️⃣ Send to API
        const res = await fetch(
          'https://backend.printtrio.co.uk/api/product/single-product',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(buildRequestPayload(extra)),
          }
        );
        const { data } = await res.json();
        if (!data) throw new Error('empty response');
    
        // 4️⃣ Core updates
        if (data.product)       setProductData(data.product);
        if (data.product?.note) setNote(data.product.note);
        if (data.vat)           setVatRate(parseFloat(data.vat));
    
        // 5️⃣ Refresh all option lists
        if (Array.isArray(data.quantity_price) && data.quantity_price.length > 0) {
          setQuantityPrice(data.quantity_price);
        }
        if (Array.isArray(data.white_color))     setWhiteColorOption(data.white_color);
        setSpotUVOptions(data.spot_UV     || []);
        setFoilingColors(data.foiling_color || []);
        setPrintedSides(data.printed_side     || []);
        setLaminations(data.lamination       || []);
        setCornerCutStyles(data.corner_cut_style || []);
        setAvailableOrientations(data.orientation || []);
      } catch (err) {
        console.error('White‑color fetch failed:', err);
      }
    };
    
    
    
    const handleSpotUVSelect = async (newSpotUV) => {
      // 1️⃣ Update local state immediately
      setSelectedSpotUV(newSpotUV);
      await fetchUpdatedProductData(
        selectedSize,
        selectedPaperType,
        selectedWeight,
        { spot_UV: newSpotUV === 'Yes' ? 1 : 0 }
      );
    
      // 2️⃣ Build only the extra fields that are actually selected
      const extra = {
        spot_UV: newSpotUV === 'Yes' ? 1 : 0,
        custom_size: 0,
        productId: productId,

      };
      if (selectedPrintedSides)      extra.printed_side      = selectedPrintedSides === 'One Side' ? 'one' : 'two';
      if (selectedFoiling)           extra.foiling_color     = selectedFoiling;
      if (selectedLamination)        extra.lamination        = selectedLamination;
      if (selectedCornerCutStyle)    extra.corner_cut_style  = selectedCornerCutStyle;
      if (selectedWhiteColor)        extra.white_color       = selectedWhiteColor === 'With white color' ? 1 : 0;
    
      try {
        // 3️⃣ Send to API
        const res = await fetch(
          'https://backend.printtrio.co.uk/api/product/single-product',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(buildRequestPayload(extra)),
          }
        );
        const { data } = await res.json();
        if (!data) throw new Error('empty response');
    
        // 4️⃣ Core updates
        if (data.product)       setProductData(data.product);
        if (data.product?.note) setNote(data.product.note);
        if (data.vat)           setVatRate(parseFloat(data.vat));
    
        // 5️⃣ Refresh all option lists
        if (Array.isArray(data.quantity_price) && data.quantity_price.length > 0) {
          setQuantityPrice(data.quantity_price);
        }
        if (Array.isArray(data.white_color))      setWhiteColorOption(data.white_color);
        setSpotUVOptions(data.spot_UV       || []);
        setFoilingColors(data.foiling_color || []);
        setPrintedSides(data.printed_side     || []);
        setLaminations(data.lamination       || []);
        setCornerCutStyles(data.corner_cut_style || []);
        setAvailableOrientations(data.orientation || []);
      } catch (err) {
        console.error('Spot‑UV fetch failed:', err);
      }
    };
    
    
    

    const handleQuantitySelect = (quantity) => {
      setSelectedQuantity(quantity); // Update the selected quantity
    };
  
    const handleDateSelect = (dateIndex) => {
      setSelectedDate(dateIndex); // Update the selected date
    };

// Handle adding custom size
// Function to update product data using custom dimensions via the API
const updateProductDimensions = async () => {
  try {
    const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId: productId,
        custom_size: 1,
        width: width,
        length: height,
      }),
    });

    const rawResponse = await response.text();
    console.log("Raw response:", rawResponse);

    // Attempt to parse JSON
    const data = JSON.parse(rawResponse);
    setProductData(data.data.product);
    setMandatory(data.data.product?.mandatory_detail ?? {});
    setPaperTypes(data.data.paper_type);
    setPaperDetails(data.data.paper_detail);
    setPaperWeights(data.data.paper_weight);
    setFiles(data.data.product.files);
  } catch (error) {
    console.error('Error updating product dimensions:', error);
  }
};


// Function to add custom size and trigger the API call
const handleAddCustomSize = async () => {

  if (
    width &&
    height &&
    !widthError &&
    !heightError &&
    width >= productData.min_width &&
    width <= productData.max_width &&
    height >= productData.min_length &&
    height <= productData.max_length
  ) {
    const newSize = `${width}mm × ${height}mm`;

    setQuantityPrice([]);
    setSelectedQuantity(null);
    setSelectedDate(0);
    setSelectedSpotUV(null);
    setSelectedWhiteColor(null);
    setSelectedCornerCutStyle('');
    setSelectedPrintedSides('');
    setSelectedOrientation('');
    setSelectedFoiling('');
    setSelectedPaperType('');
    setSelectedWeight('') 

    if (!sizes.includes(newSize)) {
      setSizes((prevSizes) => [...prevSizes, newSize]);
    }

    setSelectedSize(newSize);
    setCustomSize(newSize);
    setCustomWidth(parseFloat(width));
    setCustomHeight(parseFloat(height));

    await fetchUpdatedProductData(newSize, selectedPaperType, selectedWeight);

    setWidth('');
    setHeight('');
    setWidthError('');
    setHeightError('');
    setIsModalOpen(false);

  } else {
    console.log("Custom size validation failed:", { width, height, widthError, heightError });
  }
};

const handleAddCustomSize1 = async () => {

  if (
    width &&
    height &&
    !widthError &&
    !heightError &&
    width >= productData.min_width &&
    width <= productData.max_width &&
    height >= productData.min_length &&
    height <= productData.max_length
  ) {
    const newSize = `${width}mm × ${height}mm`;

    setQuantityPrice([]);
    setSelectedQuantity(null);
    setSelectedDate(0);
    setSelectedSpotUV(null);
    setSelectedWhiteColor(null);
    setSelectedCornerCutStyle('');
    setSelectedPrintedSides('');
    setSelectedOrientation('');
    setSelectedFoiling('');
    setSelectedPaperType('');
    setSelectedWeight('') 
    
    if (!sizes.includes(newSize)) {
      setSizes((prevSizes) => [...prevSizes, newSize]);
    }

    setSelectedSize(newSize);
    setCustomSize(newSize);
    setCustomWidth(parseFloat(width));
    setCustomHeight(parseFloat(height));
   
    setSuccessMessage(`Size ${width}mm × ${height}mm added successfully! Now, please select a Paper Type.`);

    setTimeout(() => {
      setSuccessMessage('');
    }, 10000);
    
    // 🔹 Call `fetchUpdatedProductData` immediately after setting size
    fetchUpdatedProductData(newSize, selectedPaperType, selectedWeight);
  } else {
    console.log("Custom size validation failed:", { width, height, widthError, heightError });
  }
};







// Handle modal cancellation or closure
const handleModalCancel = () => {
  setIsModalOpen(false);      // Close modal
  setCustomSize('');          // Reset customSize
  setSelectedSize(sizes[0]);  // Reset to the first size in the sizes array
};

const fetchProductData = async () => {
  try {
    const response = await fetch('https://backend.printtrio.co.uk/api/product/single-product', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId: productId,
        custom_size: 0,
      }),
    });

    const data = await response.json();
    setProductData(data.data.product);
    setMandatory(data.data.product?.mandatory_detail ?? {});
    setSizes(data.data.sizes);
    setPaperTypes(data.data.paper_type);
    setPaperDetails(data.data.paper_detail);
    setPaperWeights(data.data.paper_weight);
    setFiles(data.data.product.files);
    
  } catch (error) {
    console.error('Error fetching product:', error);
  }
};


useEffect(() => {
  if (productId) {
    // Use productId to fetch product-specific details if needed
    console.log("Product ID:", productId);
  }
}, [productId]);

useEffect(() => {
  if (productId) {
    fetchProductData(); // Fetch the data on initial load
  }
}, [productId]);


const selectedPaperDetail = paperDetails.find(
  (detail) => detail.name.toLowerCase() === selectedPaperType.toLowerCase()
);

const handleDesignRequiredChange = (event) => {
  setDesignRequired(event.target.value);
  // Reset the selected service when changing the requirement
  if (event.target.value === 'no') {
    setSelectedService('');
  }
};

const handleServiceChange = (event) => {
  setSelectedService(event.target.value);
};

const handleServiceSelect = (serviceName) => {
  setSelectedService(serviceName);
};

// const selectedItem = quantityPrice.find(item => item.quantity === selectedQuantity);
// const basePrice = selectedItem ? parseFloat(selectedItem[`price${selectedDate + 1}`]) : 0;

// const selectedServiceObject = services.find(service => service.name === selectedService);
// const selectedServicePrice = selectedServiceObject ? parseFloat(selectedServiceObject.price) : 0;

// const selectedPrice = basePrice + selectedServicePrice;

// const vatAmount = selectedPrice * vatRate; // VAT calculation
// const totalPriceWithVat = selectedPrice + vatAmount; // Total price including VAT
// const totalPriceWithoutVat = selectedPrice ;

// pick the row
const selectedItem = quantityPrice.find(item => item.quantity === selectedQuantity);

// strip commas then parse
const rawBase = selectedItem ? selectedItem[`price${selectedDate + 1}`] : '0';
const basePrice = parseFloat(rawBase.replace(/,/g, ''));

// service fee, also stripping commas
const selectedServiceObject = services.find(s => s.name === selectedService);
const rawSvc = selectedServiceObject ? selectedServiceObject.price : '0';
const selectedServicePrice = parseFloat(rawSvc.replace(/,/g, ''));

// total before VAT
const selectedPrice = basePrice + selectedServicePrice;

// VAT and totals
const isVat = productData?.is_vat === 1;
const vatAmount = isVat ? selectedPrice * vatRate : 0;
const totalPriceWithVat = selectedPrice + vatAmount;
const totalPriceWithoutVat = selectedPrice;

const buildTrackingItem = useCallback((overrides = {}) => ({
  item_id: String(productId || productData?.id || ''),
  item_name: productData?.name || '',
  item_variant: [selectedWeight, selectedPaperType].filter(Boolean).join(' ').trim() || customSize || selectedSize || '',
  price: Number.isFinite(basePrice) ? Number(basePrice.toFixed(2)) : 0,
  quantity: Number(selectedQuantity || 1),
  item_category: productData?.category?.name || productData?.category_name || '',
  ...overrides,
}), [basePrice, customSize, productData, productId, selectedPaperType, selectedQuantity, selectedSize, selectedWeight]);



// Calculate price per item
const pricePerItem = selectedQuantity && totalPriceWithVat
  ? (totalPriceWithVat / selectedQuantity).toFixed(2)  // Only calculate if both values are available
  : '0.00'; // Default value if not yet selected
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const viewKey = `${productId || productData?.id || ''}:${itemId || 'new'}`;
  if (!productData?.name || !productId || viewedItemRef.current === viewKey) {
    return;
  }

  viewedItemRef.current = viewKey;
    const trackingItem = buildTrackingItem({
      item_variant: customSize || selectedSize || '',
      price: Number.isFinite(basePrice) ? Number(basePrice.toFixed(2)) : 0,
      quantity: 1,
    });

    pushDataLayerEvent({
      event: 'view_item',
      ecommerce: {
        currency: 'GBP',
        value: Number.isFinite(basePrice) ? Number(basePrice.toFixed(2)) : 0,
        items: [trackingItem],
      },
    });
  }, [itemId, productData, productId, basePrice, customSize, selectedSize, buildTrackingItem]);
  
  
const handleClick = async () => {
  // 1️⃣ Ensure user is logged in
  if (!token) {
    setIsModalVisible(true);
    return;
  }

  // 2️⃣ Validate selections
  if (!validateSelections()) return;
  const newErrors = { size: '', paperType: '', paperWeight: '', quantity: '', service: '' };

  if (!selectedSize) newErrors.size = 'Please select a size.';
  if (!selectedPaperType) newErrors.paperType = 'Please select a paper type.';
  if (!selectedWeight) newErrors.paperWeight = 'Please select a paper weight.';
  if (!selectedQuantity) newErrors.quantity = 'Please select a quantity.';
  if (!selectedServiceObject) newErrors.service = 'Please select a service.';

  if (Object.values(newErrors).some(msg => msg)) {
    setErrors(newErrors);
    return;
  }
  setErrors({ size: '', paperType: '', paperWeight: '', quantity: '', service: '' });

  // 3️⃣ Build form data
  const formData = new FormData();
  formData.append('product_id', productId);

  // Only mark as custom if we actually have numeric dimensions:
  const isCustom = customWidth != null && customHeight != null;
  formData.append('custom_size', isCustom ? '1' : '0');

  if (isCustom) {
    formData.append('custom_width', String(customWidth));
    formData.append('custom_length', String(customHeight));
  }

  formData.append('size', selectedSize);
  formData.append('paper_type', selectedPaperType);
  formData.append('paper_weight', selectedWeight);
  formData.append(
    'printed_side',
    selectedPrintedSides === 'Two Sides' ? 'two' : 'one'
  );
  formData.append('orientation', selectedOrientation || '');
  console.log('Orientation sent:', selectedOrientation);

  formData.append('corner_cut_style', selectedCornerCutStyle);
  formData.append('lamination', selectedLamination);
  formData.append(
    'white_color',
    selectedWhiteColor === 'With white color' ? '1' : '0'
  );
  formData.append('spot_UV', selectedSpotUV === 'Yes' ? '1' : '0');
  formData.append('foiling_color', selectedFoiling);
  formData.append('quantity', String(selectedQuantity));
  formData.append('number_of_sheet', selectedItem?.number_of_sheet || '');
  formData.append('product_price', basePrice.toFixed(2));
  formData.append('total_price', totalPriceWithoutVat.toFixed(2));
  formData.append('total_price_with_vat', totalPriceWithVat.toFixed(2));
  formData.append('service_id', String(selectedServiceObject?.id || ''));
  formData.append(
    'service_description',
    serviceText || ''
  );

  // Deliver date
  const deliverDate = quantityPrice[selectedDate]?.[`date${selectedDate + 1}`];
  if (!deliverDate) {
    console.error('Delivery date is required but not selected.');
    return;
  }
  formData.append('deliver_date', deliverDate);

  // Files
  if (uploadedFiles[0]) {
    formData.append('file1', uploadedFiles[0], uploadedFiles[0].name);
  }
  if (uploadedFiles[1]) {
    formData.append('file2', uploadedFiles[1], uploadedFiles[1].name);
  }

  // 4️⃣ Send to API
  try {
    const url = itemId
      ? `https://backend.printtrio.co.uk/api/cart/edit-item/${itemId}`
      : 'https://backend.printtrio.co.uk/api/cart/add-to-cart';

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const result = await response.json();
    if (!response.ok) {
      console.error('Failed to process product:', result.errors);
      console.error('Full response:', result);
      return;
    }

    pushDataLayerEvent({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'GBP',
        value: Number.isFinite(totalPriceWithoutVat) ? Number(totalPriceWithoutVat.toFixed(2)) : 0,
        items: [buildTrackingItem()],
      },
    });

    const msg = itemId
      ? 'Product edited successfully'
      : 'Product added to cart successfully';
    navigate('/Cart', { state: { message: msg } });
  } catch (error) {
    console.error('Error processing product:', error);
  }
};


  
const handleSaveForLater = async () => {
  if (!token) {
    setIsModalVisible(true);
    return;
  }
  if (!validateSelections()) return; 
  const newErrors = { size: '', paperType: '', paperWeight: '', quantity: '', service: '' };

  if (!selectedSize) newErrors.size = 'Please select a size.';
  if (!selectedPaperType) newErrors.paperType = 'Please select a paper type.';
  if (!selectedWeight) newErrors.paperWeight = 'Please select a paper weight.';
  if (!selectedQuantity) newErrors.quantity = 'Please select a quantity.';
  if (!selectedServiceObject) newErrors.service = 'Please select a service.';

  if (newErrors.size || newErrors.paperType || newErrors.paperWeight || newErrors.quantity || newErrors.service) {
    setErrors(newErrors);
    return;
  }

  setErrors({ size: '', paperType: '', paperWeight: '', quantity: '' });

  const formData = new FormData();
  formData.append('product_id', productId);
  formData.append('custom_size', customSize ? 1 : 0);
  formData.append('custom_width', customWidth || '');
  formData.append('custom_length', customHeight || '');
  formData.append('size', selectedSize);
  formData.append('paper_type', selectedPaperType);
  formData.append('paper_weight', selectedWeight);
  formData.append('printed_side', selectedPrintedSides === 'One Side' ? 'one' : 'two');
  formData.append('orientation', selectedOrientation);
  formData.append('corner_cut_style', selectedCornerCutStyle);
  formData.append('lamination', selectedLamination);
  formData.append('white_color', selectedWhiteColor === 'With white color' ? 1 : 0);
  formData.append('spot_UV', selectedSpotUV === 'Yes' ? 1 : 0);
  formData.append('foiling_color', selectedFoiling);
  formData.append('quantity', selectedQuantity);
  formData.append('number_of_sheet', selectedItem?.number_of_sheet || '');
  formData.append('product_price', basePrice.toFixed(2));
  formData.append('total_price', totalPriceWithoutVat.toFixed(2));
  formData.append('total_price_with_vat', totalPriceWithVat.toFixed(2));
  formData.append('service_id', selectedServiceObject?.id || '');
  formData.append('service_description', serviceText || '');

  const selectedDeliveryDate = quantityPrice[selectedDate]?.[`date${selectedDate + 1}`];
  if (!selectedDeliveryDate) {
    console.error('Delivery date is required but not selected.');
    return;
  }
  formData.append('deliver_date', selectedDeliveryDate);

  if (uploadedFiles[0]) {
    formData.append('file1', uploadedFiles[0], uploadedFiles[0].name);
  }
  if (uploadedFiles[1]) {
    formData.append('file2', uploadedFiles[1], uploadedFiles[1].name);
  }

  try {
    const response = await fetch('https://backend.printtrio.co.uk/api/saved-item/add-to-saved-item', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const result = await response.json();

    if (response.ok && result.success) {
      // Successfully saved for later
      console.log('Product saved for later successfully:', result.message);
      // Redirect to /dashboard with activeLink = 'Saved Items'
      navigate('/dashboard', { state: { activeLink: 'Saved Items' } });
    } else {
      console.error('Failed to save product for later:', result.errors);
    }
  } catch (error) {
    console.error('Error saving product for later:', error);
  }
};
  
  
useEffect(() => {
  if (selectedSize && selectedPaperType && selectedWeight != null) {
    fetchUpdatedProductData(
      selectedSize,
      selectedPaperType,
      selectedWeight,
      { custom_size: customSize ? 1 : 0 }
    );
  }
}, [ selectedSize, selectedPaperType, selectedWeight, customSize ]);

  

  
  
  return (
    <>
       <Navbar />
       {isLoading ? (
  <div className="flex justify-center items-center h-screen">
    {/* simple Tailwind spinner */}
    <svg
      className="animate-spin h-12 w-12 text-pink-500"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v8H4z"
      />
    </svg>
  </div>
) : (
  <>
       <div className="p-4  mt-10 mb-10 bg-gray-100 min-h-screen max-w-screen-2xl mx-auto px-4 xl:px-20 relative">
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:m-10 min-h-screen">
  <div className="p-4 lg:p-8 xl:sticky xl:top-0 self-start z-0">

    <div className="mb-8 w-full ">
    {productData && productData.images && productData.images.length > 0 ? (
  <Swiper
    modules={[Pagination, Autoplay]}
    pagination={{ clickable: true }}
    spaceBetween={30}
    slidesPerView={1}
    autoplay={{ delay: 4000, disableOnInteraction: false }}
    loop={productData.images.length > 1}
    speed={2000}
    className="rounded"
    onSwiper={(swiper) => setSwiperInstance(swiper)}
    onSlideChange={() => {
      const videos = document.querySelectorAll('video');
      videos.forEach(video => video.pause());
    }}
  >
    {productData.images.map((media, index) => (
      <SwiperSlide key={index}>
        <div className="w-full h-auto"> {/* height is now auto */}
          {media.image.endsWith('.mp4') || media.image.endsWith('.webm') ? (
            <video
              controls
              className="w-full object-cover rounded"
              onPlay={() => swiperInstance?.autoplay.stop()}
              onEnded={() => swiperInstance?.autoplay.start()}
              onPause={() => swiperInstance?.autoplay.start()}
              style={{ width: '100%', height: 'auto' }}
            >
              <source src={media.image} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img
              src={media.image}
              alt={`Product Media ${index + 1}`}
              className="w-full object-cover rounded"
              style={{ width: '100%', height: 'auto' }}
            />
          )}
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
) : (
  <img
    src="https://via.placeholder.com/500"
    alt="Placeholder"
    className="rounded w-full lg:w-3/4 h-auto"
  />
)}


<h2 className="text-lg lg:text-xl font-bold mb-2 mt-10">{productData ? productData.name : 'Lodaing...'}</h2>
<div
  className="prose prose-sm sm:prose lg:prose-lg text-gray-600"
  dangerouslySetInnerHTML={{
    __html: productData?.description || 'Loading...',
  }}
></div>



        <div className="border border-dashed border-red-500 p-4 mt-10 text-gray-600 rounded-md">
          <div className="flex items-start">
            <img src={danger} alt="PDF" className="w-5 h-5 mr-2 mt-1.5" />
            <p>
              <span className="font-bold">Note:</span> {note}
            </p>
          </div>
        </div>

      </div>
      {productData?.files?.map((file) => (
      <div className="mb-8 w-full  ">
        <h1 className="text-lg lg:text-xl font-bold mb-2">Choose Your Preferred File Format</h1>
        <h2 className="text-gray-600 mb-4">Create Your Unique Design</h2>
        <p className="text-gray-600 mb-4">Download the preferred template format and unleash your creativity to design a unique and valid artwork!</p>
        <div className="flex space-x-4 mb-4">
  
    <a key={file.id} href={file.file} target="_blank" rel="noopener noreferrer">
      <img src={file.type.icon} alt={file.type.name} className="w-8 h-8" />
    </a>
 
</div>

      </div>

      ))}



    </div>

    {/* Right Column */}
    <div className="p-4 lg:p-8 sticky top-0 self-start z-0 min-h-screen">
<div className="flex flex-row  justify-end items-center">
     
      <div className="flex justify-end mt-4">
  <button
    className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
    onClick={() => {
      setSelectedSize('');              // Reset selected size
      setCustomSize('');                // Reset custom size
      setSelectedSpotUV(null);          // Reset Spot UV
      setSelectedWhiteColor(null);      // Reset White color
      setSelectedCornerCutStyle('');    // Reset Corner cut style
      setSelectedLamination('');        // Reset Lamination
      setSelectedPrintedSides('');      // Reset Printed sides
      setSelectedOrientation('');       // Reset Orientation
      setSelectedFoiling('');           // Reset Foiling color
      setSelectedWeight(null);          // Reset Paper weight
      setSelectedPaperType('');         // Reset Paper Type
      setQuantityPrice([]);            // ← clear the entire table
      setSelectedQuantity(null);        // ← clear any highlighted row
      setSelectedDate(0);               // ← reset date-column highlight
      fetchProductData();               // Fetch product data again to reset everything
      setHeight('');
      setWidth('');
    }}
  >
    Clear
  </button>
</div>
      </div>
      
      <div className="mb-4">
  <label className="block text-gray-700 font-bold mb-2">Size (mm)</label>
  {productData && productData.predefined_sizes === 1 && (
  <div className="flex items-center border-2 border-pink-500 rounded-xl">
    <div className="flex-1 relative">
    <select
  className="block w-full appearance-none text-pink-500 bg-transparent border-none focus:outline-none p-2 pr-8 "
  value={selectedSize || customSize || "Select Size"}
  onChange={(e) => {
    const newSize = e.target.value;
    if (newSize === "Custom Size") {
      setCustomSize('');  // Clear custom size if user opts for custom size input
      setIsModalOpen(true);  // Open modal for custom size input
    } else {
      setCustomSize('');  // Clear custom size if a regular size is selected
      setSelectedSize(newSize);  // Set the selected size
      handleSizeSelect(newSize);  // Call function to handle the selected size
    }
  }}
>
  {/* Add a default placeholder option */}

  <option value="Select Size" disabled>
    Select Size
  </option>

  {/* Map through all available sizes */}
  {sizes.map((size, index) => (
    <option key={index} value={size}>{size}</option>
  ))}

  {/* Option for Custom Size */}
  {productData && productData.custom_size === 1 && (
    <option value="Custom Size">Custom Size</option>
  )}
</select>







      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-pink-500">
        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </div>
    </div>
  </div>
  )}
  
  {productData && productData.predefined_sizes === 0 && productData.custom_size === 1 && (
  <>
    <h2 className="text-lg font-bold mb-4">Enter Custom Size</h2>

    <div className="mb-2">
      <label className="block text-gray-700 mb-2">Width (mm)</label>
      <input
        type="number"
        value={width}
        min={productData.min_width}
        max={productData.max_width}
        onChange={(e) => {
          const newWidth = e.target.value;
          setWidth(newWidth);
          if (newWidth < productData.min_width || newWidth > productData.max_width) {
            setWidthError(`Width must be between ${productData.min_width}mm and ${productData.max_width}mm`);
          } else {
            setWidthError('');
          }
        }}
        className={`border-2 border-pink-500 ${widthError ? 'border-red-500' : 'border-gray-300'} p-2 rounded-lg w-full`}
        placeholder={`Enter width (${productData.min_width}-${productData.max_width}mm)`}
      />
      {widthError && <p className="text-red-500 mt-1">{widthError}</p>}
    </div>

    <div className="mb-4">
      <label className="block text-gray-700 mb-2">Height (mm)</label>
      <input
        type="number"
        value={height}
        min={productData.min_length}
        max={productData.max_length}
        onChange={(e) => {
          const newHeight = e.target.value;
          setHeight(newHeight);
          if (newHeight < productData.min_length || newHeight > productData.max_length) {
            setHeightError(`Height must be between ${productData.min_length}mm and ${productData.max_length}mm`);
          } else {
            setHeightError('');
          }
        }}
        className={`border-2 border-pink-500  ${heightError ? 'border-red-500' : 'border-gray-300'} p-2 rounded-lg w-full`}
        placeholder={`Enter height  (${productData.min_length}-${productData.max_length}mm)`}
      />
      {heightError && <p className="text-red-500 mt-1">{heightError}</p>}
    </div>

    <div className="flex ">
      <button
        className="bg-pink-500 text-white px-4 py-2 rounded-lg"
        onClick={handleAddCustomSize1}
        disabled={
          !width || !height ||
          width < productData.min_width || width > productData.max_width ||
          height < productData.min_length || height > productData.max_length
        }
      >
        Add Size
      </button>

    </div>
    {successMessage && (
    <p className="text-green-600 text-sm mt-2">{successMessage}</p>
  )}
  </>
)}





{isModalOpen && (
  <div className="fixed inset-0 z-50 bg-gray-600 bg-opacity-50 flex items-center justify-center ">
    <div className="bg-white p-5 rounded-lg shadow-lg sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/4 max-w-xl">
      <h2 className="text-lg font-bold mb-4">Enter Custom Size</h2>

      {/* State for error messages */}
      <div className="mb-2">
        <label className="block text-gray-700">Width (mm)</label>
        <input
  type="number"
  value={width}
  min={productData.min_width}
  max={productData.max_width}
  onChange={(e) => {
    const newWidth = e.target.value;
    setWidth(newWidth);
    if (newWidth < productData.min_width || newWidth > productData.max_width) {
      setWidthError(`Width must be between ${productData.min_width}mm and ${productData.max_width}mm`);
    } else {
      setWidthError('');
    }
  }}
  className={`border-2 ${widthError ? 'border-red-500' : 'border-gray-300'} p-2 rounded-lg w-full`}
  placeholder={`Enter width (${productData.min_width}-${productData.max_width}mm)`}
/>
        {widthError && <p className="text-red-500 mt-1">{widthError}</p>} {/* Show error message */}
      </div>

      {/* Height input with range validation */}
      <div className="mb-4">
        <label className="block text-gray-700">Height (mm)</label>
        <input
  type="number"
  value={height}
  min={productData.min_length}
  max={productData.max_length}
  onChange={(e) => {
    const newHeight = e.target.value;
    setHeight(newHeight);
    if (newHeight < productData.min_length || newHeight > productData.max_length) {
      setHeightError(`Height must be between ${productData.min_length}mm and ${productData.max_length}mm`);
    } else {
      setHeightError('');
    }
  }}
  className={`border-2 ${heightError ? 'border-red-500' : 'border-gray-300'} p-2 rounded-lg w-full`}
  placeholder={`Enter height (${productData.min_length}-${productData.max_length}mm)`}
/>
        {heightError && <p className="text-red-500 mt-1">{heightError}</p>} {/* Show error message */}
      </div>

      <div className="flex justify-between">
      <button
  className="bg-pink-500 text-white px-4 py-2 rounded-lg"
  onClick={handleAddCustomSize}
  disabled={
    !width || !height ||
    width < productData.min_width || width > productData.max_width ||
    height < productData.min_length || height > productData.max_length
  }
>
  Add Size
</button>


        <button
  className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
  onClick={handleModalCancel} // Reset to the first size on cancel
>
  Cancel
</button>
      </div>
    </div>
  </div>
)}

</div>


<div className="mt-8 mb-8">
  <label className="block text-gray-700 font-bold mb-6">Paper Type</label>

  <div className="flex flex-col lg:flex-row">
    {/* Paper Types Buttons */}
    <div className="lg:w-1/2">
    <select
  id="paperType"
  value={selectedPaperType}
  onChange={(e) => handlePaperTypeSelect(e.target.value)}
  className={`block w-full rounded-xl p-2 outline-none bg-transparent border-2
    ${selectedPaperType
      ? 'border-pink-500 text-pink-500'
      : 'border-pink-500 text-pink-500'}`}
>
  <option value="" disabled>
    Select a paper type
  </option>
  {paperTypes.map((type) => (
    <option key={type} value={type}>
      {type}
    </option>
  ))}
</select>

  
</div>


    {/* Paper Detail Section */}
    <div className="flex-1 lg:ml-5 mt-10 md:mt-0">
      <div className="flex justify-center items-center bg-gray-200 w-full lg:w-3/4  rounded-xl mb-8 mx-auto">
        {/* Render the image dynamically */}
        {selectedPaperDetail ? (
          <img
            src={selectedPaperDetail.image}
            alt={selectedPaperDetail.name}
            className="object-contain rounded-xl"
          />
        ) : (
          <p>No image available</p>
        )}
      </div>

      {/* Paper Type Title */}
      <h3 className="font-bold">{selectedPaperType}</h3>

      {/* Paper Description */}
      <p className="text-gray-500 mb-2 ">
        {selectedPaperDetail ? selectedPaperDetail.description : 'No description available.'}
      </p>

      {/* Paper Weight Section */}
      <label className="block text-gray-700 font-bold mb-2">Choose paper weight (GSM)</label>
      <div className="flex">
      {paperWeights.map((weight) => (
  <button
    key={weight}
    className={`border p-2 rounded ${
      String(selectedWeight) === String(weight)
    ? 'border-pink-500 text-pink-500' 
    : 'border-gray-300 text-gray-700'
    } mx-1`}
    onClick={() => handlePaperWeightSelect(weight)}
  >
    {weight}
  </button>
))}
</div>

    </div>
  </div>
</div>

{Array.isArray(foilingColors) && foilingColors.length > 0 && (
<div className="mb-4">

  <label className="block text-gray-700 font-bold mb-2">Foiling color</label>
  <div className="flex items-center border-2 border-pink-500 rounded-xl">
    <div className="flex-1 relative">
      <select
        className="block w-full text-pink-500 bg-transparent border-none focus:outline-none p-2 pr-8"
        value={selectedFoiling}  // Keep the initial value as an empty string
        onChange={(e) => handleFoilingColorSelect(e.target.value)}  // Call handleFoilingColorSelect on change
      >
        {/* Placeholder Option */}
        <option value="" disabled>
      Select Foiling Color
    </option>

        {/* Dynamically render options */}
        {foilingColors.map((color, index) => (
          <option key={index} value={color}>
            {color}
          </option>
        ))}
      </select>

      {/* Dropdown icon */}
  
    </div>
  </div>
 
</div>
 )}






      <div className="mt-8 mb-8">
      {availableOrientations.length > 0 && (
  <div className="mb-4">
    <label className="block text-gray-700 font-bold mb-4">Orientation</label>
    <div className="flex flex-row space-x-2">
  {availableOrientations.map(option => (
    <button
      key={option}
      className={`border p-4 rounded text-center w-full lg:w-1/3 flex flex-col lg:flex-row items-center justify-center gap-5 ${
        selectedOrientation === option ? 'border-pink-500 text-pink-500' : 'border-gray-300 text-gray-700'
      }`}
      onClick={() => handleOrientationSelect(option)}
    >
      <div className={`mb-4 lg:mb-0 ${getSizeClasses(option)} ${
        selectedOrientation === option ? 'border-2 border-pink-500' : 'border-2 border-gray-500'
      }`}></div>
      {option.charAt(0).toUpperCase() + option.slice(1)}
    </button>
  ))}
</div>

  </div>
)}
{ printedSides.includes('one') && printedSides.includes('two') && (
        <div className="mb-4 flex flex-col lg:flex-row justify-between">
        <div className="w-full lg:w-1/2 mr-0 lg:mr-2 mb-4 lg:mb-0">
  <label className="block text-gray-700 font-bold mb-2">Printed sides</label>
  <div className="flex items-center border-2 border-pink-500 rounded-xl">
    <div className="flex-1 relative">
      <select
        value={selectedPrintedSides}
        onChange={(e) => {
          handlePrintedSidesSelect(e.target.value);
          setUploadedImageUrl('');  // Clear first image
          setUploadedImageUrl2(''); // Clear second image if present
          setSelectedImage('first'); // Reset to first image selection
        }}
        className="block w-full text-pink-500 bg-transparent border-none focus:outline-none p-2 pr-8"
      >
        <option value="" disabled>
          Select Printed Sides
        </option>

        {/* Dynamically render options by mapping through `printedSides` */}
        {printedSides.map((side, index) => (
          <option key={index} value={side === 'one' ? 'One Side' : 'Two Sides'}>
            {side === 'one' ? 'One Side' : 'Two Sides'}
          </option>
        ))}
      </select>


    </div>
  </div>
</div>


{Array.isArray(laminations) && laminations.length > 0 && (
<div className="w-full lg:w-1/2 ml-0 lg:ml-2">
  <label className="block text-gray-700 font-bold mb-2">Lamination</label>
  <div className="flex items-center border-2 border-pink-500 rounded-xl">
    <div className="flex-1 relative">
      <select
        value={selectedLamination || ""}  // Ensure the default "Select Lamination" option is shown
        onChange={(e) => handleLaminationSelect(e.target.value)}  // Update state on change
        className="block w-full text-pink-500 bg-transparent border-none focus:outline-none p-2 pr-8"
      >
        {/* Placeholder option */}
        <option value="" disabled>
          Select Lamination
        </option>

        {/* Dynamically render lamination options */}
        {laminations.map((lamination, index) => (
          <option key={index} value={lamination}>
            {lamination}
          </option>
        ))}
      </select>


    </div>
  </div>
</div>
)}


        </div>
        )}
        {Array.isArray(cornerCutStyles) && cornerCutStyles.length > 0 && (
  <div className="mb-4">
    <label className="block text-gray-700 font-bold mb-4">Corner cut style</label>
    <div className="flex flex-row justify-between space-x-2">
      {cornerCutStyles.map(option => (
        <button
          key={option}
          className={`border p-4 rounded-xl text-center w-full lg:w-1/2 mx-0 lg:mx-1 flex flex-col lg:flex-row items-center gap-5 ${
            selectedCornerCutStyle === option ? 'border-pink-500 text-pink-500' : 'border-gray-300 text-gray-700'
          }`}          
          onClick={() => handleCornerCutStyleSelect(option)}
        >
          <div
            className={`h-16 w-full lg:w-1/2 flex justify-center items-center mt-4 mb-4 lg:mt-0 lg:mb-0 ${
              selectedCornerCutStyle === option ? 'border-2 border-pink-500' : 'border-2 border-gray-500'
            } ${option.toLowerCase() === 'round' ? 'rounded-xl' : ''}`}
          >
            <div className={`h-8 w-16 ${option.toLowerCase() === 'round' ? 'rounded-xl' : ''}`}></div>
          </div>
          {option}
        </button>
      ))}
    </div>
  </div>
)}


<div className="mb-4 flex flex-col lg:flex-row justify-between">
{ whiteColorOption.includes(0) && whiteColorOption.includes(1) && (
  <div className="w-full lg:w-1/2 mr-0 lg:mr-2 mb-4 lg:mb-0">
    <label className="block text-gray-700 font-bold mb-2">White color</label>
    <p className="text-gray-500 mb-2">White ink will make your print stand out on this paper. Choose if you like to add it
    </p>
    <div className="flex justify-start items-center gap-5 mt-4">
      {/* "With White Color" option */}
      <select
    id="whiteColor"
    value={selectedWhiteColor || ""}
    onChange={e => handleWhiteColorSelect(e.target.value)}
    className="
    block w-full border-2 rounded-xl p-2 text-gray-700 outline-none ring-2 ring-pink-500 text-pink-500 bg-transparent
    "
  >
    <option value="" disabled hidden>
      Select white color option
    </option>
    <option value="Without white color">Without white color</option>
    <option value="With white color">With white color</option>
   
  </select>
    </div>
  </div>
)}



  <div className="w-full lg:w-1/2 ml-0 lg:ml-2">
  {spotUVOptions.includes(0) && spotUVOptions.includes(1) && (
      <>
        <label className="block text-gray-700 font-bold mb-2">Spot UV</label>
        <p className={`text-gray-500 mb-2 ${whiteColorOption.includes(0) && whiteColorOption.includes(1) ? 'md:mb-8' : ''}`}>
  Do you require spot UV?
</p>

        <div className={`flex justify-start items-center gap-5 mt-0 ${whiteColorOption.includes(0) && whiteColorOption.includes(1) ? 'lg:mt-16' : ''}`}>


          {spotUVOptions.includes(0) && spotUVOptions.includes(1) && (
             <select
             id="spotUV"
             value={selectedSpotUV || ""}
             onChange={e => handleSpotUVSelect(e.target.value)}
             className="
             block w-full border-2 rounded-xl p-2 text-gray-700 outline-none ring-2 ring-pink-500 text-pink-500 bg-transparent
             "
           >
             <option value="" disabled hidden>
             Select spot UV option
             </option>
             <option value="No">No</option>
             {spotUVOptions.includes(0) && <option value="Yes">Yes</option>}
           </select>
   
          )}
        </div>
      </>
    )}
  </div>
</div>

        
      </div>

      <div className="mt-8 mb-8">
  <label className="block text-gray-700 font-bold mb-4">Quantity</label>
  <p className="text-sm text-gray-500 mt-2 mb-5">
    {selectedQuantity && selectedDate !== null ? (
      `Note: You have selected ${selectedQuantity} items. Your estimated delivery date is ${quantityPrice[0]?.[`date${selectedDate + 1}`]} with a total price of £${quantityPrice.find(item => item.quantity === selectedQuantity)?.[`price${selectedDate + 1}`]}.` 
    ) : (
      "Please select a quantity and receive by date."
    )}
  </p>
  <div className="overflow-x-auto border-collapse border border-pink-500">
    <table className="min-w-full">
      <thead>
        <tr>
          <th className="border p-2 text-xs md:text-sm">QTY</th>
          <th className="border p-2 text-xs md:text-sm">RECEIVE BY<br />{quantityPrice[0]?.date3}</th>
          <th className="border p-2 text-xs md:text-sm">RECEIVE BY<br />{quantityPrice[0]?.date2}</th>
          <th className="border p-2 text-xs md:text-sm">RECEIVE BY<br />{quantityPrice[0]?.date1}</th>
          {userData.role === 'admin' && ( <th className="border p-2 text-xs md:text-sm">NUMBER <br /> OF SHEET</th> )}
        </tr>
      </thead>
      <tbody>
  {quantityPrice.map((item, index) => (
    <tr key={index} className={`${selectedQuantity === item.quantity ? 'bg-pink-100' : ''}`}>
      <td
        className={`border p-2 text-center cursor-pointer ${selectedQuantity === item.quantity ? 'bg-pink-500 text-white' : ''}`}
        onClick={() => handleQuantitySelect(item.quantity)}
      >
        {item.quantity}
      </td>
      <td
        className={`border p-2 text-center cursor-pointer ${selectedQuantity === item.quantity && selectedDate === 2 ? 'bg-pink-500 text-white' : ''}`}
        onClick={() => {
          handleQuantitySelect(item.quantity);
          handleDateSelect(2);
        }}
      >
        £{item.price3}
      </td>
      <td
        className={`border p-2 text-center cursor-pointer ${selectedQuantity === item.quantity && selectedDate === 1 ? 'bg-pink-500 text-white' : ''}`}
        onClick={() => {
          handleQuantitySelect(item.quantity);
          handleDateSelect(1);
        }}
      >
        £{item.price2}
      </td>
      <td
        className={`border p-2 text-center cursor-pointer ${selectedQuantity === item.quantity && selectedDate === 0 ? 'bg-pink-500 text-white' : ''}`}
        onClick={() => {
          handleQuantitySelect(item.quantity);
          handleDateSelect(0);
        }}
      >
        £{item.price1}
      </td>
            {userData.role === 'admin' && (
        <td className="border p-2 text-center">
           {item.number_of_sheet}
          </td>
        )}
    </tr>
  ))}
</tbody>

    </table>
  </div>
</div>


    {/* Display Selected Price and Date */}
<div className="flex flex-col lg:flex-row text-center mt-4 gap-10 mb-10">
  <p className="text-pink-500">
    <strong>Date Time:</strong> Receive by {quantityPrice[0]?.[`date${selectedDate + 1}`]}
  </p>
  {selectedQuantity && quantityPrice.find(item => item.quantity === selectedQuantity) ? (
    <p className="text-pink-500">
     <strong>Price:</strong> £{quantityPrice.find(item => item.quantity === selectedQuantity)[`price${selectedDate + 1}`]}
      
    </p>
  ) : (
    <p className="text-pink-500">Please select a quantity and date</p>
  )}
</div>



      
<div>
  <h2 className="text-xl font-semibold mb-4 text-start">Choose a Service</h2> {/* Title */}

  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8 mb-8">
    {console.log("Rendering services:", services)}
    {services.map((service) => (
      <div
        key={service.id}
        className={`flex flex-col justify-between p-4 border-2 rounded-lg text-center cursor-pointer ${selectedService === service.name ? 'border-pink-500' : 'border-blue-500'}`}
        onClick={() => handleServiceSelect(service.name)}
      >
        <div className="flex flex-row justify-between mb-4">
          <span className="text-lg font-semibold">{service.name}</span>
          <div className="flex justify-center">
            <input
              type="radio"
              checked={selectedService === service.name}
              onChange={() => handleServiceSelect(service.name)}
              className="text-pink-500"
            />
          </div>
        </div>
        <div className="mb-4 text-gray-500">
          <p>{service.description}</p>
          <p className="font-semibold mt-2">Price: £{parseFloat(service.price).toFixed(2)}</p>
        </div>
      </div>
    ))}
  </div>
</div>









{selectedService !== "I have a print-ready file" && (
  <div className="mb-4">
    <label className="block text-gray-700 font-bold mb-4">Describe what you're looking for:</label>
    <textarea
      className="mt-1 block w-full border border-gray-300 rounded p-6 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent"
      rows="4"
      value={serviceText}
      onChange={e => setServiceText(e.target.value)}

    ></textarea>
  </div>
)}


      <p className="text-red-500 font-semibold mb-4">
  Note: To upload two images, please select "Two Sides" from the Printed Sides option.
</p>

      <div
  {...getRootProps()}
  className="bg-gray-200 border-2 border-gray-300 p-4 text-center rounded shadow mb-8 flex flex-col items-center pt-10 pb-10 w-full"
>
  <input {...getInputProps()} />
  <img src={image} alt="image" className="w-12 h-12 mb-5" />
  {isDragActive ? (
    <p className="text-black">Drop the files here ...</p>
  ) : (
    !fileUploaded ? (
      <>
        <p className="text-black">Drag and Drop Files Here</p>
        <p className="text-gray-400">or <span className="text-pink-500 cursor-pointer">Browse</span> to choose a file</p>
      </>
    ) : (
      <div className="flex flex-col items-center">
        <p className="text-black">Uploaded file(s): {fileName}</p>
        {/* Display first image */}
        
      </div>
    )
  )}
</div>
{fileRejections.length > 0 && (
        <div className="text-red-500 mt-2">
          {fileRejections.map(({ file, errors }) => (
            <p key={file.path}>
              {file.path} was rejected because: {errors.map(e => e.message).join(', ')}
            </p>
          ))}
        </div>
      )}


{/* Conditionally Render Proof Check Button */}
{/* {fileUploaded && (
  <div className="p-4 text-center mb-8 flex flex-col items-center w-full">
    <button
      className={`flex items-center text-white px-4 py-2 rounded-full gap-3 ${!selectedSize ? 'cursor-not-allowed opacity-50' : ''}`} // Disable button styles
      style={{ backgroundColor: '#EC008C' }}
      onClick={() => {
        if (selectedSize) {
          setIsProofModalOpen(true); 
        }
      }}
      disabled={!selectedSize} 
    >
      Proof check
    </button>
    {!selectedSize && (
      <p className="text-red-500 text-sm mt-2">
        Please select a size before proceeding with the proof check.
      </p> // Display error message if no size selected
    )}
  </div>
)} */}

   

     {isProofModalOpen && (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
  <div className="bg-white rounded-lg shadow-lg w-full h-full lg:h-auto lg:w-3/4 p-4 lg:p-6 relative mx-0 lg:mx-0"> {/* Full screen for mobile and regular for lg */}
    <h2 className="text-xl font-bold mb-4">Upload File</h2>
    <button
      className="absolute top-4 right-5 text-gray-500 hover:text-black"
      onClick={() => setIsProofModalOpen(false)} // Close modal on click
    >
      ✕
    </button>

    <div className="flex flex-col lg:flex-row justify-between mb-4 gap-10 overflow-y-auto lg:overflow-visible h-full lg:h-auto "> 
      {/* Left Side */}
      <div className="w-full pt-14 border border-blue-100 bg-blue-50 relative rounded-lg overflow-auto pt-10 pb-10">
  {/* Product Image with Multi-Layer Borders */}
  <div className="relative flex justify-center items-center overflow-auto pt-20" style={{ maxHeight: '400px', maxWidth: '1000px' }}> {/* Limit container size */}
    
    {/* Pink Border - Outer */}
    <div
      className="border-8 border-pink-300 rounded-md flex justify-center items-center"
      style={{
        width: mmToPx(outerWidth + 3),
        height: mmToPx(outerHeight + 3),
        maxWidth: '100%', // Ensure it doesn't exceed parent width
        maxHeight: '100%', // Ensure it doesn't exceed parent height
      }}
    >
      {/* Yellow Border with Image */}
      <div
        className="relative border-4 border-yellow-300 rounded-md flex justify-center items-center"
        style={{
          width: mmToPx(outerWidth),
          height: mmToPx(outerHeight),
          maxWidth: '100%', // Ensure it doesn't exceed parent width
          maxHeight: '100%', // Ensure it doesn't exceed parent height
        }}
      >
        <div
          className="relative border-4 border-blue-500 rounded-md flex justify-center items-center"
          style={{
            width: mmToPx(outerWidth - 3),
            height: mmToPx(outerHeight - 3),
            zIndex: 10,
            maxWidth: '100%', // Ensure it doesn't exceed parent width
            maxHeight: '100%', // Ensure it doesn't exceed parent height
          }}
        >
          {/* Main Image Centered */}
          <div className="flex justify-center items-center text-gray-700 font-bold text-xl">
            {selectedImage === 'first' ? (
              <img
                src={uploadedImageUrl} // First image
                alt="Uploaded File Preview"
                style={{
                  objectFit: 'contain',
                  width: '100%',
                  height: '100%',
                  maxWidth: '100%',
                  maxHeight: '100%',
                }}
                className="rounded-md"
              />
            ) : (
              <img
                src={uploadedImageUrl2} // Second image
                alt="Uploaded File Preview"
                style={{
                  objectFit: 'contain',
                  width: '100%',
                  height: '100%',
                  maxWidth: '100%',
                  maxHeight: '100%',
                }}
                className="rounded-md"
              />
            )}
          </div>
        </div>
      </div>
    </div>

{/* Horizontal size guide */}
<div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full text-gray-600 font-semibold mt-20">
  <span className="ml-3">{outerWidth || 0}mm</span> 
  <img src={arrow2} alt="Horizontal Arrow" className="w-20 mb-2" />
  {console.log("Displaying horizontal size guide:", outerWidth)} {/* Log outerWidth for proof */}
</div>

{/* Vertical size guide */}
<div className="absolute top-1/2 left-16 transform -translate-y-1/2 -translate-x-full text-gray-600 font-semibold rotate-90">
  <img src={arrow2} alt="Vertical Arrow" className="w-20" />
  <span className="ml-3">{outerHeight || 0}mm</span> 
  {console.log("Displaying vertical size guide:", outerHeight)} {/* Log outerHeight for proof */}
</div>



  </div>

  {/* Thumbnails (Two Image Squares) */}
  <div className="flex justify-center items-center gap-5 mt-4">
    {/* First Image Square */}
    <div
      className={`border-4 p-1 cursor-pointer ${selectedImage === 'first' ? 'border-pink-500' : 'border-gray-300'}`}
      onClick={() => setSelectedImage('first')} // Set first image as selected
      style={{ width: '100px', height: '100px' }} // Small square size
    >
      <img
        src={uploadedImageUrl} // Thumbnail of the first image
        alt="First Image"
        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
        className="rounded-md"
      />
    </div>

    {/* Conditionally render second image square if "Two Sides" is selected */}
    {selectedPrintedSides === 'Two Sides' && uploadedImageUrl2 && (
      <div
        className={`border-4 p-1 cursor-pointer ${selectedImage === 'second' ? 'border-pink-500' : 'border-gray-300'}`}
        onClick={() => setSelectedImage('second')} // Set second image as selected
        style={{ width: '100px', height: '100px' }} // Small square size
      >
        <img
          src={uploadedImageUrl2} // Thumbnail of the second image
          alt="Second Image"
          style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          className="rounded-md"
        />
      </div>
    )}
  </div>
</div>



      {/* Right Side */}
      <div className="w-full lg:w-1/3 p-4 pb-14 xl:pb-0 border border-gray-200 bg-blue-50 relative rounded-lg overflow-auto">
        {/* Title */}
        <h3 className="text-gray-900 font-semibold text-lg mb-2">Your Proofs</h3>

        {/* File Uploaded & Page Count Section */}
        <div className="p-2 mb-2 bg-white border border-blue-200 rounded-lg">
          <div className="flex items-center mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 text-green-500 mr-2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 12l4 4L19 7" />
            </svg>
            <span className="text-green-500 font-medium">File uploaded</span>
          </div>
        </div>

        <div className="p-2 mb-2 bg-white border border-blue-200 rounded-lg">
  <div className="flex justify-between items-center">
    <span className="text-sm text-gray-900 font-semibold">Bleed and safe area</span>
   
  </div>
</div>

{/* Always Display Content */}
<div className="mt-2 mb-4 bg-white p-4 shadow-lg border rounded-lg z-50 w-full">
  <p className="text-sm font-semibold text-gray-700 mb-2">Selected size: {outerWidth}mm x {outerHeight}mm</p>

  {/* Bleed area */}
  <div className="p-2 border-l-4 border-red-500 mb-4">
    <p className="text-sm font-semibold text-gray-900">Bleed Line:</p>
    <p className="text-xs text-gray-600">This is the outermost edge beyond the trim line where the artwork extends, ensuring no white edges appear after trimming.</p>
  </div>

  {/* Trim area */}
  <div className="p-2 border-l-4 border-yellow-500 mb-4">
    <p className="text-sm font-semibold text-gray-900">Trim Line:</p>
    <p className="text-xs text-gray-600">This is the final edge where the printed artwork will be cut to its finished size.</p>
  </div>

  {/* Safe area */}
  <div className="p-2 border-l-4 border-blue-500">
    <p className="text-sm font-semibold text-gray-900">Safe Area:</p>
    <p className="text-xs text-gray-600">It is the area inside the trim line where important content, such as text and images, should be placed to avoid being cut off.</p>
  </div>
</div>




        <p className="text-xs text-gray-500 mb-2">*Please note, a reprint or refund would not be available if you are unsatisfied with your print, as you have chosen to proceed despite the errors.</p>

        <button className="w-full bg-pink-500 text-white py-2 rounded-full hover:bg-pink-600 mt-5 mb-4"
         onClick={() => setIsProofModalOpen(false)}
        >
          Submit</button>
      </div>
    </div>
  </div>
</div>

)}

<div className="p-6 bg-white rounded shadow mb-8 border-2 w-full mt-10" style={{ borderColor: '#EC008C' }}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg lg:text-xl font-bold">Product Summary</h2>

        </div>
        {selectedQuantity && selectedDate !== null && selectedItem ? (
  <div className="flex justify-between items-center mb-4 font-bold text-lg">
    <span>Subtotal</span>
    <span>
      £{selectedPrice.toFixed(2)}
    </span>
  </div>
) : (
  <div className="flex justify-between items-center mb-4 font-bold text-lg">
    <span>Subtotal</span>
    <span>£0.00</span>
  </div>
)}

<div className="flex justify-between items-center mb-4">
  <span>VAT</span>
  <span>£{isVat ? vatAmount.toFixed(2) : '0.00'}</span>
</div>


{selectedQuantity && selectedDate !== null && selectedItem ? (
  <div className="flex justify-between items-center mb-4 font-bold text-lg">
    <span>Total {isVat ? '(Inc VAT)' : ''}</span>
    <span>
      £{totalPriceWithVat.toFixed(2)}
    </span>
  </div>
) : (
  <div className="flex justify-between items-center mb-4 font-bold text-lg">
    <span>Total {isVat ? '(Inc VAT)' : ''}</span>
    <span>£0.00</span>
  </div>
)}


<div className="flex justify-between items-center mt-6">
<button
  className="flex items-center text-white px-4 py-2 rounded-full gap-3"
  style={{ backgroundColor: '#EC008C' }}
  onClick={handleClick}
>
  {itemId ? 'Edit Cart' : 'Add To Cart'} <img src={arrow} alt="image" className="w-4 h-4" />
</button>

<button
    className="flex items-center text-white px-4 py-2 rounded-full gap-3 ml-4"
    style={{ backgroundColor: '#EC008C' }}
    onClick={handleSaveForLater}
  >
    Save For Later
  </button>


</div>

{/* Display Error Messages */}
<div className="mt-4">
  {errors.size && <p className="text-red-500 text-sm">{errors.size}</p>}
  {errors.paperType && <p className="text-red-500 text-sm">{errors.paperType}</p>}
  {errors.paperWeight && <p className="text-red-500 text-sm">{errors.paperWeight}</p>}
  {errors.quantity && <p className="text-red-500 text-sm">{errors.quantity}</p>}
  {errors.service && <p className="text-red-500 text-sm">{errors.service}</p>}
  {errors.printedSide  && <p className="text-red-500 text-sm">{errors.printedSide}</p>}
{errors.orientation  && <p className="text-red-500 text-sm">{errors.orientation}</p>}
{errors.lamination   && <p className="text-red-500 text-sm">{errors.lamination}</p>}
{errors.foilingColor && <p className="text-red-500 text-sm">{errors.foilingColor}</p>}
{errors.cornerCut    && <p className="text-red-500 text-sm">{errors.cornerCut}</p>}
{errors.spotUV       && <p className="text-red-500 text-sm">{errors.spotUV}</p>}
{errors.whiteColor   && <p className="text-red-500 text-sm">{errors.whiteColor}</p>}

</div>

      </div>
    </div>
  </div>
</div>

{isModalVisible && (
        <LoginModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        onLoginSuccess={handleLoginSuccess}  // Pass the success handler
      />
      )}

    <Products />
   <Sample />
   <Subscribe />
   <FixedImageMessage />
    <Footer />
    </>
    )}
    </>
  );
};

export default Product;
